var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Banking & Finance/coins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.333 3.33366C13.333 2.41318 11.0944 1.66699 8.33301 1.66699C5.57158 1.66699 3.33301 2.41318 3.33301 3.33366V6.66699C3.33301 7.58747 5.57158 8.33366 8.33301 8.33366C11.0944 8.33366 13.333 7.58747 13.333 6.66699V3.33366Z",
    fill: "#8278F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03715 12.0803C3.99251 12.3858 3.33301 12.834 3.33301 13.3337V16.667C3.33301 17.5875 5.57158 18.3337 8.33301 18.3337C11.0944 18.3337 13.333 17.5875 13.333 16.667V14.9157C12.7968 14.9716 12.2369 15.0003 11.6663 15.0003C10.1563 15.0003 8.72012 14.7988 7.60376 14.4266C7.05429 14.2435 6.4894 13.9887 6.02764 13.6248C5.65153 13.3283 5.17302 12.8157 5.03715 12.0803Z",
    fill: "#8278F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 9.91568V11.667C6.66634 12.5875 8.90492 13.3337 11.6663 13.3337C14.4278 13.3337 16.6663 12.5875 16.6663 11.667V8.33366C16.6663 7.83405 16.0068 7.38578 14.9622 7.08031C14.8263 7.81573 14.3478 8.32834 13.9717 8.62475C13.5099 8.98866 12.9451 9.24349 12.3956 9.42664C11.2792 9.79876 9.84301 10.0003 8.33301 10.0003C7.7625 10.0003 7.20252 9.97155 6.66634 9.91568Z",
    fill: "#E5E5E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/price_icon.2fc9f1226570874060d5dbe8facdd359.svg";
export { ForwardRef as ReactComponent };